import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { getItem } from "@/utils/tokenTools";
import store from "../store";

if (process.env.VUE_APP_MODE !== "library") {
  Vue.use(VueRouter);
}

const routes = [
  {
    path: "/Purchase/Activated",
    name: "EmailReturnPage",
    component: () => import("@/views/EmailReturnPage.vue"),
    props: (route) => ({ query: route.query }),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      mainTitle: "Müşteriler",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [],
      baseMenuName: "dashboard",
    },
  },
  {
    path: "/buy-data-package/:customerNumber/:customerId",
    name: "BuyDataPackage",
    component: () => import("@/views/BuyDataPackage.vue"),
    meta: {
      mainTitle: "Müşteriler",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "Dashboard",
          icon: "dashboard",
          url: { name: "Home" },
        },
      ],
      baseMenuName: "dashboard",
    },
  },
  {
    path: "/customer/:customerNumber/:customerId?",
    name: "CustomerDetail",
    component: () => import("@/views/CustomerDetail.vue"),
    meta: {
      mainTitle: "Müşteriler",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "Dashboard",
          icon: "dashboard",
          url: { name: "Home" },
        },
      ],
      baseMenuName: "dashboard",
    },
  },
  {
    path: "/checkout/:customerNumber/:packageNumber",
    name: "Checkout",
    component: () => import("@/views/Checkout.vue"),
    meta: {
      mainTitle: "Müşteriler",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "Dashboard",
          icon: "dashboard",
          url: { name: "Home" },
        },
      ],
      baseMenuName: "dashboard",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/under-construction",
    name: "UnderConstruction",
    component: () => import("@/components/base/UnderConstruction.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/reports/represreports",
    name: "RepresReports",
    component: () => import("@/views/RepresReports.vue"),
    meta: {
      mainTitle: "Müşteri Raporları",
      requiresAuth: true,
      layout: "AppLayout",
      baseMenuName: "musteri-raporlari",
    },
  },
  {
    path: "/reports/get-manuel-report",
    name: "GetManuelReport",
    component: () => import("@/views/ManualReport.vue"),
    meta: {
      mainTitle: "Manuel Müşteri Raporları",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "Manuel Müşteri Raporları",
          icon: "doc-magnifier",
          url: { name: "GetManuelReport" },
        },
      ],
      baseMenuName: "manuel-musteri-raporlari",
    },
  },
  {
    path: "/product-and-package-management/:pageName?",
    name: "ProductAndPackageManagement",
    component: () => import("@/views/ProductAndPackageManagement.vue"),
    meta: {
      mainTitle: "Ürün ve Paket Yönetimi",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "Ürün ve Paket Yönetimi",
          icon: "file-box-dark",
          url: { name: "ProductAndPackageManagement" },
        },
      ],
      baseMenuName: "urun-ve-paket-yonetimi",
    },
  },
  {
    path: "/month-closing",
    name: "MonthClosing",
    component: () => import("@/views/MonthClosing.vue"),
    meta: {
      mainTitle: "Ay Kapama İşlemleri",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "Ay Kapama İşlemleri",
          icon: "month-closing-dark",
          url: { name: "MonthClosing" },
        },
      ],
      baseMenuName: "ay-kapama-islemleri",
    },
  },
  {
    path: "/global-parameters",
    name: "ParametersPage",
    component: () => import("@/views/ParametersPage.vue"),
    meta: {
      mainTitle: "Global Parametre Tanımla",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "Global Parametreler",
          icon: "month-closing-dark",
          url: { name: "ParametersPage" },
        },
      ],
      baseMenuName: "global-parameters",
    },
  },
  {
    path: "/users-roles",
    name: "UsersRole",
    component: () => import("@/views/UsersRole.vue"),
    meta: {
      mainTitle: "Kullanıcı Rolleri",
      requiresAuth: true,
      layout: "AppLayout",
      baseMenuName: "users-role",
    },
  },
  {
    path: "/recommended-packages",
    name: "RecommendedPackages",
    component: () => import("@/views/RecommendedPackages.vue"),
    meta: {
      mainTitle: "En Çok Kullanılan Paketler",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "En Çok Kullanılan Paketler",
          icon: "bag",
          url: { name: "RecommendedPackages" },
        },
      ],
      baseMenuName: "onerilen-paketler",
    },
  },
  {
    path: "/recommended-packages/buy",
    name: "BuyRecomendedPackage",
    component: () => import("@/views/BuyDataPackage.vue"),
    meta: {
      mainTitle: "En Çok Kullanılan Paketler",
      requiresAuth: true,
      layout: "AppLayout",
      breadcrumb: [
        {
          name: "En Çok Kullanılan Paketler",
          icon: "bag",
          url: { name: "RecommendedPackages" },
        },
        {
          name: "Paket Oluştur",
          icon: "",
          url: { name: "BuyRecomendedPackage" },
        },
      ],
      baseMenuName: "onerilen-paketler",
    },
  },
  {
    path: "*",
    redirect: "/login",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const loginUrl = process.env.VUE_APP_LOGIN_URL;
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (getItem("veri-dagitim-token")) {
      if (
        from.name == "CustomerDetail" &&
        store.getters.getIsPurchaseOrUpgradeHappend &&
        to.name == "Checkout"
      ) {
        next();
      } else if (
        from.name == "CustomerDetail" &&
        !store.getters.getIsPurchaseOrUpgradeHappend &&
        to.name == "Checkout"
      ) {
        next({
          name: "CustomerDetail",
          params: {
            customerId: from.params ? from.params.customerId : from.query.c,
            customerNumber: from.params.customerNumber,
          },
        });
      } else {
        next();
      }
    } else {
      next({
        name: loginUrl,
        params: { nextUrl: to.fullPath },
      });
    }
  } else {
    next();
  }
});

router.onError((error) => {
  console.log("Router error: ", error);
  router.push({
    name: "Login",
  });
});

export default router;
